import { Component } from '@angular/core';

@Component({
  selector: 'app-cancelaciones-devoluciones',
  templateUrl: './cancelaciones-devoluciones.component.html',
  styleUrls: ['../../../assets/css/footer-pages.css'],
})
export class CancelacionesDevolucionesComponent {}
